import React, { useState, useEffect } from 'react';

function AdditionalChargeForm({ gigId, charge, gig, onSave, onCancel }) {
  const [formData, setFormData] = useState({
    charge_type: 'operation',
    amount: '',
    notes: '',
    substitute_name: ''
  });

  useEffect(() => {
    if (charge) {
      setFormData({
        charge_type: charge.charge_type || 'operation',
        amount: charge.amount ? charge.amount.toString() : '',
        notes: charge.notes || '',
        substitute_name: charge.substitute_name || ''
      });
    } else {
      setFormData({
        charge_type: 'operation',
        amount: '',
        notes: '',
        substitute_name: ''
      });
    }
  }, [charge, gig]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.amount) {
      alert('Please fill in the amount');
      return;
    }

    if (formData.charge_type === 'sub' && !formData.substitute_name?.trim()) {
      alert('Please enter the substitute name');
      return;
    }

    onSave({
      id: charge?.id,
      gig_id: gigId,
      charge_type: formData.charge_type,
      amount: parseFloat(formData.amount),
      notes: formData.notes || null,
      substitute_name: formData.charge_type === 'sub' ? (formData.substitute_name?.trim() || null) : null
    });
  };

  return (
    <div className="expense-form">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="charge_type">Charge Type *</label>
            <select
              id="charge_type"
              name="charge_type"
              value={formData.charge_type}
              onChange={handleChange}
              required
            >
              <option value="operation">Operation</option>
              <option value="programming">Programming</option>
              <option value="sub">Sub</option>
            </select>
        </div>

        <div className="form-group">
          <label htmlFor="amount">Amount (€) *</label>
          <input
            type="number"
            id="amount"
            name="amount"
            value={formData.amount}
            onChange={handleChange}
            required
            min="0"
            step="0.01"
            placeholder="150.00"
          />
        </div>

        {formData.charge_type === 'sub' && (
          <div className="form-group">
            <label htmlFor="substitute_name">Substitute Name *</label>
            <input
              type="text"
              id="substitute_name"
              name="substitute_name"
              value={formData.substitute_name}
              onChange={handleChange}
              required
              placeholder="Name of the substitute"
            />
          </div>
        )}

        <div className="form-group">
          <label htmlFor="notes">Notes</label>
          <textarea
            id="notes"
            name="notes"
            value={formData.notes}
            onChange={handleChange}
            rows="3"
            placeholder="Add any notes about this charge..."
          />
        </div>

        <div className="btn-group">
          <button type="submit" className="btn btn-primary">
            {charge ? 'Update Charge' : 'Add Charge'}
          </button>
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default AdditionalChargeForm;

